import React from "react";
import PropTypes from "prop-types";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Card from "antd/lib/card";
import Tabs from "antd/lib/tabs";
import Table from "antd/lib/table";
import Button from "antd/lib/button";
import { OrderedMap, List } from "immutable";
import "styles/v2/card.css";

const TabPane = Tabs.TabPane;

const columns = new OrderedMap({
    parameter_name: {
        key: "parameter_name",
        title: "Name",
        dataIndex: "parameter_name",
        width: 100
    },
    description: {
        key: "description",
        title: "Description",
        dataIndex: "description",
        width: 200
    },
    evaluation_condition: {
        key: "evaluation_condition",
        title: "Condition",
        dataIndex: "evaluation_condition",
        width: 100,
        render: _ => _.label,
    },
    parameter_threshold: {
        key: "parameter_threshold",
        title: "Threshold",
        dataIndex: "parameter_threshold",
        width: 100,
    },
    parameter_applicability: {
        key: "parameter_applicability",
        title: "Applicability",
        dataIndex: "parameter_applicability",
        width: 100
    },
    deviation_support_options: {
        key: "deviation_support_options",
        title: "Deviation Reasons",
        dataIndex: "deviation_support_options",
        width: 120
    },
    test_run_analysis: {
        key: "test",
        title: "Run",
        dataIndex: "test_run_analysis",
        width: 30,
    }
});

const data = List([]);


class LenderAnalysis extends React.Component {

    getTitle = () => {
        return(
            <Row>
                <Col span={12} >

                </Col>
                <Col span={12} >
                    <Row type={"flex"} justify={"end"}>
                        <Col style={{ padding: "0px 5px"}}>
                            <Button type={"link"} icon={"edit"}>
                                Edit
                            </Button>
                        </Col>
                        <Col style={{ padding: "0px 5px"}}>
                            <Button  type={"link"} icon={"caret-right"}>
                                Run Back Test
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }

    render() {
        return (
            <Row>
                <Col className={"mb-10"}>
                    <Card className={"v2-ant-card"}>
                        <Row>
                            <Col span={4}>
                                <Tabs size={"middle"} tabPosition={"left"} >
                                    <TabPane key={"sanction-utilization"} tab={"Sanction Utilization"}/>
                                    <TabPane key={"pipeline-summary"} tab={"Pipeline Summary"}/>
                                    <TabPane key={"repayments-summary"} tab={"Repayment Summary"}/>
                                    <TabPane key={"overdue-summary"} tab={"Overdue Summary"}/>
                                </Tabs>
                            </Col>
                            <Col span={20}>
                                
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col>
                    <Table
                        title={this.getTitle}
                        columns={columns}
                        dataSource={data}
                        size={"small"}
                    />
                </Col>
            </Row>
        );
    }


}

LenderAnalysis.propTypes = {
    route: PropTypes.object
};

export default LenderAnalysis;